// Index.js - Composant Modal
import React, {useRef, useState} from 'react';
import {Col, Modal, Row} from "antd";
import FormOwner from "./FormOwner";
import useUserCredential from "../../hooks/extranet/useUserCredential";
import TableProduct from "./TableProduct";

const Index = ({open, setOpen, owner, products, setUser, user}) => {

  const formRef = useRef();
  const { createCredentials, updateCredentials } = useUserCredential();
  const [lots, setLots] = useState([]);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleCloseModal = () => {
    setUser(null);
    setOpen(false);
  };

  const handleSubmitForm = () => {
    // Bloque le bouton (anti click multiple)
    setConfirmLoading(true);

    // Déclencher la soumission du formulaire
    formRef.current?.submit();
  };

  const handleFormSubmitSuccess = async (values) => {
    //console.log('Formulaire soumis avec succès:', values);
    //console.log('Lots sélectionnés:', lots);

    // Merge le propriétaire et les lots sélectionnés
    const dataToSubmit = {
      ...values,
      lots: lots,
      owner: owner.proprietaire_id,
    };

    if (user) { // Mise à jour
      await updateCredentials(user.id, dataToSubmit);
    } else { // Création
      const result =  await createCredentials(dataToSubmit);
      if (result) {
        owner.proprietaire_extranet = result.id;
        //console.log('Données complètes à soumettre:', result);
      }
    }

    // Fermer la modale après succès
    setOpen(false);
    setConfirmLoading(false);
  };

  const handleFormSubmitError = (errorInfo) => {
    console.log('Erreur de soumission:', errorInfo);
    // La modal reste ouverte en cas d'erreur
  };

  //console.log(owner);
  //console.log(products);

  return (
    <>
      <Modal
        title={user ? "Modification de compte extranet" : "Création de compte extranet"}
        centered
        open={open}
        onOk={handleSubmitForm}  // Soumission du formulaire
        onCancel={handleCloseModal}  // Fermeture sans soumission
        confirmLoading={confirmLoading}
        okText={user ? "Modifier le compte" : "Créer le compte"}
        cancelText="Annuler"
        width="100%"
        style={{maxWidth: '1000px'}}
      >
        <Row gutter={[24, 24]}>
          {/* Section Formulaire - 50% sur desktop, 100% sur mobile */}
          <Col xs={24} md={12}>
            <FormOwner
              ref={formRef}
              owner={owner}
              user={user}
              onSubmitSuccess={handleFormSubmitSuccess}
              onSubmitError={handleFormSubmitError}
            />
          </Col>
          {/* Section Tableau - 50% sur desktop, 100% sur mobile */}
          <Col xs={24} md={12}>
            <TableProduct owner={owner} user={user} products={products} setLots={setLots} />
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default Index;